import { ICloudServiceRegion } from '@cloud-cost-calculation-tool/base-cloud-services';

export const AZURE_BASIC_REGIONS: Array<ICloudServiceRegion> = [{ name: 'EU Central', value: 'westeurope' }];
